import React, { useContext } from "react";
import { AiFillStar } from "react-icons/ai";
import { BsArrowRight } from "react-icons/bs";
import { FiLock } from "react-icons/fi";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { BsXLg } from "react-icons/bs";
// @ts-ignore
import Image from "../../Assets/Images/Sat-images/second-Arrow .webp";
// @ts-ignore
import Girl from "../../Assets/Images/Sat-images/navbar-girl-image-.webp";
import "../../scss/SatStyles.scss";
// @ts-ignore
import UserContext from "../../utils/UserContext";

export interface CoursesProps {
  isError: string | boolean;
  Error?: string;
  satCourseData: any[];
  HandleId: (id: string | number, index: number) => void;
  HandleBookMarkScreen: () => void;
  HandleGoBack: () => void;
  HandleHidden: () => void;
}

const Courses: React.FC<CoursesProps> = (props) => {
  const { satCourseData, activeIndex, setActiveIndex } = useContext<any>(UserContext);
  return (
    <div className="st-navbar-main-container">
      {props.isError ? (
        <h1>{props.isError}</h1>
      ) : (
        <div className="sat-navbarsub-main-container">
          <div className="sat-navbar-container">
            {window.innerWidth < 1024 ? (
              <div
                className="cross-button"
                onClick={() => {
                  props.HandleHidden();
                }}
              >
                <BsXLg size="22" />
              </div>
            ) : (
              ""
            )}
            <div className="sat-about-panel">
              <div className="sat-about-section">
                <h1>About</h1>
                <div className="sat-about-p">
                  <p>
                    <AiFillStar size="17px" fill="#FFAA00 " />{" "}
                    <span className="st-rating">
                      {satCourseData && satCourseData[0]
                        ? (satCourseData[0]?.rating).toFixed(1)
                        : 0}
                    </span>
                  </p>
                </div>
              </div>

              <p className="st-navbar-paragraph">
                {satCourseData && satCourseData[0] ? satCourseData[0]?.about : ""}
              </p>
            </div>
            <div className="st-Second-section">
              <div className="st-lesson">Lesson</div>
              <div className="st-Graph-navbar">
                <CircularProgressbar
                  value={
                    satCourseData && satCourseData[0]
                      ? parseInt(satCourseData[0]?.progressPercent)
                      : 0
                  }
                  strokeWidth={10}
                  text={
                    satCourseData && satCourseData[0]
                      ? `${parseInt(satCourseData[0]?.progressPercent)}%`
                      : "0%"
                  }
                />
              </div>
            </div>
            <div className="st-Third-section">
              <div className="st-List">
                {satCourseData && satCourseData.length > 0 &&
                  satCourseData[0].modules?.map((item: any, index: number) => {
                    return (
                      <div
                        className={
                          activeIndex === index
                            ? "st-List-item st-list-item-active "
                            : "st-List-item "
                        }
                        key={item.id}
                        onClick={
                          window.innerWidth < 1024
                            ? () => {
                                props.HandleId(item.id, index);
                                props.HandleHidden();
                              }
                            : () => {
                                props.HandleId(item.id, index);
                              }
                        }
                      >
                        <div>
                          <div className="st-list-item-title">
                            <h6>{item.title}</h6>
                          </div>
                          <div className="st-list-item-description">
                            <p>{`${item.chaptersCount} Chapters`}</p>
                          </div>
                        </div>
                        <div
                          className={
                            item.check
                              ? "st-list-icon st-list-icon-bg"
                              : "st-list-icon"
                          }
                        >
                          {item.check === true ? (
                            <FiLock size="15px" color="#807f7f" />
                          ) : (
                            <BsArrowRight size="15px" color="white" />
                          )}
                        </div>
                      </div>
                    );
                  })}
                {/* second item */}
                <div
                  className={
                    activeIndex === 3
                      ? "st-List-item st-list-item-active "
                      : "st-List-item"
                  }
                  onClick={
                    window.innerWidth < 1024
                      ? () => {
                          setActiveIndex(3);
                          props.HandleBookMarkScreen();
                          props.HandleHidden();
                        }
                      : () => {
                          setActiveIndex(3);
                          props.HandleBookMarkScreen();
                        }
                  }
                >
                  <div>
                    <div className="st-list-item-title bm-pd">
                      <h6>Bookmark</h6>
                    </div>
                    <div className="st-list-item-description"></div>
                  </div>
                  <div className={"st-list-icon"}>
                    <BsArrowRight size="15px" color="white" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default React.memo(Courses);
